var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightFitting01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,14.08c-2.59,0-4.7-2.11-4.7-4.7s2.11-4.7,4.7-4.7s4.7,2.11,4.7,4.7S10.59,14.08,8,14.08z M8,5.18 c-2.31,0-4.2,1.88-4.2,4.2c0,2.31,1.88,4.2,4.2,4.2s4.2-1.88,4.2-4.2C12.2,7.07,10.31,5.18,8,5.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.94,5.16 9.44,5.16 9.44,2.42 6.9,2.42 6.9,5.16 6.4,5.16 6.4,1.92 9.94,1.92  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightFitting01);
export default __webpack_public_path__ + "static/media/LightFitting-01.4f661ec1ebc509af899bbc6de03fb795.svg";
export { ForwardRef as ReactComponent };